module.exports = __webpack_public_path__ + "static/media/template-4.3b41e423.png";